import { RootState } from "..";

export const getUserData = (state: RootState) => state.user.user?.user_data
